module.exports = __webpack_public_path__ + "static/media/remove_prod.e1c5d20f.svg";